export const addStyleToUserbackWidget = (
  styles: { [key: string]: string},
): void => {
  const el = document.querySelector('#userback_button_container .userback-button-se');
  if (!el) return;

  for (const [key, value] of Object.entries(styles)) {
    (el as HTMLElement).style[key] = value;
  }
};

export const addStyleToLiveChatWidget = (
  styles: { [key: string]: string},
): void => {
  const el = document.querySelector('.woot-widget-bubble');
  if (!el) return;

  for (const [key, value] of Object.entries(styles)) {
    (el as HTMLElement).style[key] = value;
  }
};

export const addStyleToScrollToTopBtn = (
  styles: { [key: string]: string},
): void => {
  const el = document.querySelector('#scrollToTopBtn');
  if (!el) return;

  for (const [key, value] of Object.entries(styles)) {
    (el as HTMLElement).style[key] = value;
  }
};

export const hideFloatingWidgets = () => {
  addStyleToUserbackWidget({
    display: 'none',
  });
  addStyleToLiveChatWidget({
    display: 'none',
  });
  addStyleToScrollToTopBtn({
    display: 'none',
  });
};

export const showFloatingWidgets = () => {
  addStyleToUserbackWidget({
    display: 'block',
  });
  addStyleToLiveChatWidget({
    display: 'flex',
  });
  addStyleToScrollToTopBtn({
    display: 'block',
  });
};
